import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { initSentry } from './lib/sentry';
import { initPosthog } from './lib/posthog';
import { installExternalDomGuard } from './lib/externalDomGuard';
import { installStaleAssetRecovery, syncDeployVersion } from './lib/deployVersionSync';
import { applyPersistedContrast } from './lib/outdoorContrast';

installExternalDomGuard();
installStaleAssetRecovery();
// Apply persisted outdoor high-contrast overlay before first paint (no flash).
applyPersistedContrast();

// Paint immediately — do not wait on VERSION.txt or analytics SDKs.
createRoot(document.getElementById('root')!).render(<App />);

void syncDeployVersion();

function deferAnalyticsInit(): void {
  initSentry();
  initPosthog();
}

const ric = window.requestIdleCallback;
if (typeof ric === 'function') {
  ric(() => deferAnalyticsInit(), { timeout: 2000 });
} else {
  window.setTimeout(deferAnalyticsInit, 0);
}
